import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#003d82] to-[#004a9c] flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-9xl font-black text-white/20 mb-4">404</h1>
          <div className="w-24 h-1 bg-[#f5a623] mx-auto mb-8"></div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl">
          <h2 className="text-3xl font-bold text-[#003d82] mb-4">
            Página Não Encontrada
          </h2>
          <p className="text-gray-600 text-lg mb-8">
            Desculpe, a página que procura não existe ou foi movida.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-[#003d82] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#002a5c] transition-all hover:shadow-lg"
            >
              <Home size={20} />
              Voltar à Página Inicial
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center gap-2 bg-[#f5a623] text-[#003d82] px-8 py-4 rounded-lg font-semibold hover:bg-[#e59b1f] transition-all hover:shadow-lg"
            >
              <ArrowLeft size={20} />
              Voltar Atrás
            </button>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mt-8 text-white">
          <p className="text-sm mb-4">Ou visite uma destas páginas:</p>
          <div className="flex flex-wrap gap-4 justify-center text-sm">
            <Link to="/sobre" className="hover:text-[#f5a623] transition-colors">
              Sobre Nós
            </Link>
            <Link to="/servicos" className="hover:text-[#f5a623] transition-colors">
              Serviços
            </Link>
            <Link to="/horarios" className="hover:text-[#f5a623] transition-colors">
              Horários
            </Link>
            <Link to="/contacto" className="hover:text-[#f5a623] transition-colors">
              Contactos
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
